import { Navigate } from "react-router-dom";
import Login from "@/components/auth/login/login";
import Signup from "@/components/auth/signup/signup";
import ForgotPassword from "@/components/auth/recovery/forgot";
import AdminLogin from "@/components/auth/admin-login/login";
import AdminForgotPassword from "@/components/auth/admin-login/forgot";
import SetupPassword from "@/components/auth/setup-password/setup-password";
import VerifyEmail from "@/components/auth/verify-email/verify-email";

export const authRoutes = [
  { path: "/auth", element: <Navigate to="/auth/login" replace /> },
  { path: "/login", element: <Navigate to="/auth/login" replace /> },
  { path: "/auth/login", element: <Login /> },
  { path: "/register", element: <Navigate to="/auth/register" replace /> },
  { path: "/auth/register", element: <Signup /> },
  { path: "/auth/forgot-password", element: <ForgotPassword /> },
  { path: "/verify-email", element: <VerifyEmail /> },
  { path: "/setup-password", element: <SetupPassword /> },
  { path: "/admin/login", element: <AdminLogin /> },
  { path: "/admin/forgot-password", element: <AdminForgotPassword /> },
];
